export default "__VITE_ASSET__7bd16c89__"